/* app/js/src/components/content-control/studio/content-control-studio/shared-objects/zoom-out-icon/zoom-out-icon.component.scss */
:host {
  display: flex;
}
/*# sourceMappingURL=zoom-out-icon.component.css.map */
